import { useContext } from "react"
import { Box, Button, Flex } from "@chakra-ui/react"
import { LabelXSmall } from "@mezo-org/mezo-clay"

import {
  selectActiveToken,
  selectDepositFromAnotherWallet,
  useDappSelector,
} from "#/redux-state"
import TooltipLabel from "#/shared/components/TooltipLabel"
import { FlowContext } from "#/shared/context"
import { useAnotherWalletToggle } from "#/shared/hooks"

export default function DepositToggleWallet() {
  const depositFromAnotherWallet = useDappSelector(
    selectDepositFromAnotherWallet,
  )

  const activeToken = useDappSelector(selectActiveToken)

  const { isBitcoinFlow } = useContext(FlowContext)

  const { isToggleDisabled, toggleHandler } = useAnotherWalletToggle()

  return (
    <TooltipLabel
      value={
        activeToken === "BTC"
          ? "Depositing from BTC wallet"
          : "Only available for BTC"
      }
      props={{
        px: 4,
        py: 2,
        fontSize: "16px",
        rounded: "2px",
        display: isBitcoinFlow ? "none" : "inline-block",
      }}
    >
      <Box
        minW="220px"
        h="80px"
        bg="primary.black.100"
        p={6}
        pt="24px"
        rounded="8px"
      >
        <Flex
          w="100%"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <LabelXSmall
            color="white"
            overrides={{
              Block: {
                style: () => ({ opacity: isToggleDisabled ? 0.5 : 1 }),
              },
            }}
          >
            Send from <br />
            another wallet
          </LabelXSmall>
          <Button
            variant="unstyled"
            borderColor="primary.white.100"
            borderWidth="2px"
            borderStyle="solid"
            h={8}
            w="60px"
            rounded="15px"
            pos="relative"
            opacity={isToggleDisabled ? 0.5 : 1}
            onClick={toggleHandler}
          >
            <Box
              opacity={isToggleDisabled ? 0.5 : 1}
              rounded="100%"
              h="24px"
              w="24px"
              bg={
                depositFromAnotherWallet
                  ? "primary.white.100"
                  : "primary.white.40"
              }
              pos="absolute"
              top="2px"
              right={depositFromAnotherWallet ? "1px" : "calc(100% - 25px)"}
              transition="all .2s ease"
            />
          </Button>
        </Flex>
      </Box>
    </TooltipLabel>
  )
}
